import React from 'react';
import { func, bool } from 'prop-types';
import classnames from 'classnames';

import { Checkbox } from '@thd-olt-component-react/checkbox';
import { noop } from '../../utils/promo-utils';

import './PromoCheckboxCta.scss';

export const PromoCheckboxCta = ({
  onSelect, selected, isInDrawer
}) => {

  const checkboxClasses = classnames('promo-checkbox-cta-container', {
    'promo-checkbox-cta-container--drawer': isInDrawer,
  });

  return (
    <Checkbox
      id="promo-checkbox-cta"
      checked={selected}
      onChange={onSelect}
      value="promo-checkbox-cta"
      className={checkboxClasses}
    >
      {selected ? 'Free Gift Selected' : 'Select Your Free Gift'}
    </Checkbox>
  );
};

PromoCheckboxCta.displayName = 'PromoCheckboxCta';

PromoCheckboxCta.propTypes = {
  onSelect: func,
  selected: bool,
  isInDrawer: bool,
};

PromoCheckboxCta.defaultProps = {
  onSelect: noop,
  selected: true,
  isInDrawer: false,
};
